module.exports = __webpack_public_path__ + "static/scale-model-of-king-phillip's-stockade-in-springfield-massachusetts-587684710759721d99e27df0c6124430.png";